import { useEffect, useRef } from 'react';
import { REACT_APP_RECAPTCHA_V2_SITE_KEY } from '../../components/common/Routes/URLs';

const useRecaptchaV2Widget = (showRecaptchaV2, onVerify) => {
  const onVerifyRef = useRef(onVerify);
  onVerifyRef.current = onVerify;

  useEffect(() => {
    if (!showRecaptchaV2 || !REACT_APP_RECAPTCHA_V2_SITE_KEY || !window.grecaptcha?.render) {
      return undefined;
    }

    const host = document.getElementById('recaptcha-v2');
    if (!host || host.querySelector('iframe')) {
      return undefined;
    }

    const slot = document.createElement('div');
    host.appendChild(slot);

    let widgetId;
    try {
      widgetId = window.grecaptcha.render(slot, {
        sitekey: REACT_APP_RECAPTCHA_V2_SITE_KEY,
        callback: (token) => onVerifyRef.current(token)
      });
    } catch (error) {
      slot.remove();
      if (!String(error?.message || error).includes('already been rendered')) {
        throw error;
      }
      return undefined;
    }

    return () => {
      if (widgetId !== undefined && window.grecaptcha?.reset) {
        window.grecaptcha.reset(widgetId);
      }
      slot.remove();
    };
  }, [showRecaptchaV2]);
};

export default useRecaptchaV2Widget;
